import React from 'react';

import { Box, Typography, TypographyProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

interface Props extends TypographyProps {
	text: string;
	endAdornment: JSX.Element;
}

const HighlightedText = (props: Props) => {
	const classes = useStyles();

	return (
		<Box className={classes.wrapper}>
			<Typography variant="body2" className={classes.text}>
				{props.text}
			</Typography>
			{!!props.endAdornment && props.endAdornment}
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		wrapper: {
			background: theme.palette.background.secondary,
			borderRadius: '2px',
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			padding: theme.spacing(0.5),
		},
		text: {
			flex: 1,
			padding: theme.spacing(2),
			wordBreak: 'break-all',
		},
	}),
);

export default HighlightedText;
